import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import { RadioButton } from "primereact/radiobutton";        
import { FilterMatchMode } from "primereact/api";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import axios from "axios";
import { SERVICE_LOCATION, GET_FITTERS_API, GET_DEPOTS_API, SAVE_FITTER_DETAILS_API, GENERATE_QRCODE, GET_FITTERS_FROM_PLANNER_NOT_IN_FITAPP } from "./../constants/endpoints";
import { FILL_PASSWORD_CHANGE_SECTION, PASSWORD_NOT_MATCHING, QRCODE_DOWNLOADED } from "./../constants/errors";

import "./../assets/styles/table.css";
import "./../assets/styles/fitter.css";

const Fitters = (props) => {
    const toast = useRef(null);

    const [fitters, setFitters] = useState(null);

    const [selectedFitter, setSelectedFitter] = useState(null);
    const [showFitterModal, setShowFitterModal] = useState(false);

    const [depots, setDepots] = useState(null);    
    
    const [fitterId, setFitterId] = useState(0);
    const [firstName, setFirstName] = useState("");
    const [middleName, setMiddleName] = useState("");
    const [lastName, setLastName] = useState("");    
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [passwordHash, setPasswordHash] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [userName, setUserName] = useState("");
    const [depot, setDepot] = useState(null);
    const [isActive, setIsActive] = useState(false); 
    const [isPrimaryFitter, setIsPrimaryFitter] = useState(false); 
    const [isAddFitter, setIsAddFitter] = useState(false);  
    const [isFitterExistsInPlanner, setIsFitterExistsInPlanner] = useState(null);
    const [fittersFromPlannerNotInFitapp, setFittersFromPlannerNotInFitapp] = useState(null);
    const [selectedFitterFromPlanner, setSelectedFitterFromPlanner] = useState(null);
    const [showFitterFields, setShowFitterFields] = useState(false);
    
    const ukPhoneNumberRegex = /^(?:\+44|0)\d{10}$/;

    const [firstNameError, setFirstNameError] = useState(false);
    const [lastNameError, setLastNameError] = useState(false);
    const [phoneError, setPhoneError] = useState(false);
    const [userNameError, setUserNameError] = useState(false);
    const [depotError, setDepotError] = useState(false);

    const [loading, setLoading] = useState(false);

    const { data } = props;
    const userDepot = (data !== undefined && data !== null) ? data.data.userDetails.depot : "";
    const isAdmin = (data !== undefined && data !== null) ?  (((data.data.userDetails.position).toLowerCase()).includes("admin") ? true : false) : false;

    const requestData = {
        depot: userDepot
    }
    
    let fittersFromPlannerNotInFitappErrorMessage = "";
    useEffect(() => {                
         getFitters();
         getDepots();
    }, [])  
    
    const getFitters = async () => {
        const endPoint = SERVICE_LOCATION + GET_FITTERS_API;
        await axios.post(endPoint, requestData, {
            headers: {
              Authorization: `Bearer ${data.data.token}`,
            },
          })
        .then((response) => {
            if(response.data.isSuccess){
                const allFitters = response.data.data.fitterDetails;
                setFitters(allFitters);
            }
            else if(!response.data.isSuccess){
                toast.current.show({severity:"error", summary: "Error", detail: response.data.errorMessage, life: 3000});
            }
        })
        .catch((error) => {
            toast.current.show({severity:"error", summary: "Error", detail: error, life: 3000});
        })
    }

    const GetFittersFromPlannerNotInFitapp = async () => {
        const endPoint = SERVICE_LOCATION + GET_FITTERS_FROM_PLANNER_NOT_IN_FITAPP;
        await axios.get(endPoint, {
            headers: {
              Authorization: `Bearer ${data.data.token}`,
            },
          })
        .then((response) => {
            if(response.data.isSuccess){
                const fittersNotInApp = response.data.data.fittersFromPlannerNotInFitapp;
                setFittersFromPlannerNotInFitapp(fittersNotInApp);
                setIsFitterExistsInPlanner(true);
            }
            else if(!response.data.isSuccess){
                setFittersFromPlannerNotInFitapp(null);
                setIsFitterExistsInPlanner(null);
                toast.current.show({severity:"error", summary: "Error", detail: response.data.errorMessage, life: 5000});
            }
        })
        .catch((error) => {
            setFittersFromPlannerNotInFitapp(null);
            toast.current.show({severity:"error", summary: "Error", detail: error, life: 5000});
        })
    }

    const getDepots = async () => {
        const endPoint = SERVICE_LOCATION + GET_DEPOTS_API;
        await axios.get(endPoint, {
            headers: {
              Authorization: `Bearer ${data.data.token}`,
            },
          })
        .then((response) => {
            if(response.data.isSuccess){
                setDepots(response.data.data.getDepots);                        
            }
            else if(!response.data.isSuccess){
                toast.current.show({severity:"error", summary: "Error", detail: response.data.errorMessage, life: 3000});
            }

        })
        .catch((error) => {
            toast.current.show({severity:"error", summary: "Error", detail: error, life: 3000});
        })
    }

    const getQRCode = (fitterDetails) => {
        setLoading(true);
        const requestedData = {
            userName: fitterDetails.userName,
            password: fitterDetails.passwordHash
        }
        const endPoint = SERVICE_LOCATION + GENERATE_QRCODE;
        axios.post(endPoint, requestedData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                setLoading(false);
                if (response.data.isSuccess) {
                    const qrcode = response.data.data.qrCodeDetails;
                    const base64String = "data:application/pdf;base64," + qrcode.workCardBase64String;
                    const linkSource = base64String;
                    const downloadLink = document.createElement("a");
                    const fileName = qrcode.fileName;
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();

                    toast.current.show({ severity: "success", summary: "success", detail: QRCODE_DOWNLOADED, life: 5000 });
                }
                else if (!response.data.isSuccess) {
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
                }

            })
            .catch((error) => {
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
            })
    }

    const handleAddFitter = () => {
        setShowFitterModal(true);
        setIsAddFitter(true);
        setDefaultDepotForFitter();
    }

    // Search functionality
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        firstName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        middleName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        lastName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        primaryFitter: { value: null, matchMode: FilterMatchMode.CONTAINS },
        userName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        isPrimaryFitter: { value: null, matchMode: FilterMatchMode.CONTAINS},
        isActive: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    const [globalFilterValue, setGlobalFilterValue] = useState("");    

    const renderHeader = () => {
        return (
            <div className="row">
                {isAdmin && 
                    <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                        <div className="card flex">
                            <Button id="add-fitter" label="Add Fitter" onClick={handleAddFitter} />
                        </div>
                    </div>
                }
                <div className={isAdmin ? "col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10" : ""}>
                    <div className="flex justify-content-end txt-right">
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters["global"].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };    

    const header = renderHeader();
    // Search functionality Ends here

    const setDefaultDepotForFitter = () => {
        setDepot({depotCode: data.data.userDetails.depotCode, depot: userDepot}); 
    }

    const onRowSelect = async (event) => {   
        if(isAdmin) {     
            setSelectedFitter(event.data);
            setFitterId(event.data.fitterId);
            setFirstName(event.data.firstName);
            setMiddleName(event.data.middleName.trim());
            setLastName(event.data.lastName);
            setPhone(event.data.phone);
            setEmail(event.data.email);       
            setDepot({depotCode: event.data.depotCode, depot: event.data.depot}); 
            setUserName(event.data.userName);
            setIsActive(event.data.isActive === "Y" ? true : false);
            setIsPrimaryFitter(event.data.isPrimaryFitter === "Y" ? true : false);
            setPasswordHash(event.data.passwordHash);
            setShowFitterFields(true);
            setIsFitterExistsInPlanner(false);
            setShowFitterModal(true);
        }
    };        

    // Modal for fitter details 
    const clearModalFields = () => {
        setShowFitterModal(false);
        setIsAddFitter(false);
        setFirstName("");
        setMiddleName("");
        setLastName("");
        setPhone("");
        setEmail("");
        setDepot(null);
        setUserName("");
        setNewPassword("");
        setConfirmPassword("");
        setIsFitterExistsInPlanner(null);
        setSelectedFitterFromPlanner(null);
        setShowFitterFields(false);

        setFirstNameError(false);
        setLastNameError(false);
        setPhoneError(false);
        setUserNameError(false);
        setDepotError(false);
    }

    const onModalClose = () => {        
        clearModalFields();
    }

    const saveFitterDetails = async (updatedHashedPassword) => {
        const saveFitterDetailsEndPoint = SERVICE_LOCATION + SAVE_FITTER_DETAILS_API;
        const saveDetailsRequestData = {
            isAddFitter: isAddFitter,
            fitterId: fitterId,
            firstName: firstName.toUpperCase().trim(),
            middleName: middleName.trim() !== "" ? middleName.toUpperCase().trim() + " " : "",
            lastName: lastName.toUpperCase().trim(),
            phone: phone,
            email: email.toLowerCase().trim(),
            depot: depot.depotCode,
            userName: userName.toLowerCase().trim(),
            passwordHash: updatedHashedPassword,
            isPrimaryFitter: isPrimaryFitter ? "Y" : "N",
            isActive: isActive ? "Y" : "N",
            isFitterExistsInPlanner: isFitterExistsInPlanner
        }
        await axios.post(saveFitterDetailsEndPoint, saveDetailsRequestData, {
            headers: {
              Authorization: `Bearer ${data.data.token}`,
            },
          })
        .then((response) => {
            if(response.data.isSuccess) {
                clearModalFields();
                getFitters();
                var alertMsg = isAddFitter ? "New fitter has been succesfully created with fiiter username '" + response.data.data.newUserName + "'" : response.data.errorMessage;
                toast.current.show({severity:"success", summary: "Success", detail: alertMsg, life: 5000});            
            }
            else if(!response.data.isSuccess) {
                toast.current.show({severity:"error", summary: "Error", detail: response.data.errorMessage, life: 5000});
            }
        })
        .catch((error) => {
            toast.current.show({severity:"error", summary: "Error", detail: error, life: 3000});
        })
    }

    const handleSave = () => {
        const isValid = phone.trim() === "" ? true : ukPhoneNumberRegex.test(phone);    
        firstName.trim() === "" ? setFirstNameError(true) : setFirstNameError(false);
        lastName.trim() === "" ? setLastNameError(true) : setLastNameError(false);
        phone.trim() !== "" && !isValid ? setPhoneError(true) : setPhoneError(false);
        !isAddFitter && userName.trim() === "" ? setUserNameError(true) : setUserNameError(false);
        depot === null ? setDepotError(true) : setDepotError(false);

        if((newPassword === "" && confirmPassword !== "") || (newPassword !== "" && confirmPassword === "") ) {
            toast.current.show({severity:"error", summary: "Error", detail: FILL_PASSWORD_CHANGE_SECTION, life: 5000});
        } 
        else if(newPassword !== confirmPassword) {
            toast.current.show({severity:"error", summary: "Error", detail: PASSWORD_NOT_MATCHING, life: 5000});
        }        
        else if(firstName.trim() !== "" && lastName.trim() !== "" && depot !== null ) {            
            saveFitterDetails(passwordHash);
        }
    }

    const handleExistingFitterSelection = (event) => {
        setSelectedFitter(event.value);
        setFitterId(event.value.fitterId);     
        setDepot({depotCode: event.value.depotCode, depot: event.value.depot}); 
        setIsActive(event.value.isActive === "Y" ? true : false);
        setIsPrimaryFitter(event.value.isPrimaryFitter === "Y" ? true : false);

        setSelectedFitterFromPlanner(event.value);
        setShowFitterFields(true);
    }

    const handleIsExistsInPlanner = (e) => {
        const selectedValue = e.value;
        setSelectedFitterFromPlanner(null);
        if(selectedValue === "Yes") {
            setShowFitterFields(false); 
            const errorMessage = "";
            GetFittersFromPlannerNotInFitapp();
            if(fittersFromPlannerNotInFitappErrorMessage === "") {
                setIsFitterExistsInPlanner(true);                
            }
            else {
                setIsFitterExistsInPlanner(false);
                toast.current.show({severity:"error", summary: "Error", detail: errorMessage, life: 5000});
            }                       
        }
        else {
            setIsFitterExistsInPlanner(false);
            setShowFitterFields(true);
        }
    }

    const footerContent = (
        <div>
            <Button label="Cancel" icon="pi pi-times" onClick={onModalClose} className="p-button-text" />
            <Button label={isAddFitter ? "Add" : "Save"} icon="pi pi-check" onClick={handleSave} autoFocus />
        </div>
    );    
    // Modal functionality ends here    

    const generateQRCode = (rowdata) => {        
        getQRCode(rowdata);
    }

    const getQRCodeButton = (rowdata) => {
        return <Button label="QRCode" onClick={() => generateQRCode(rowdata)} link style={{fontSize: "12px", paddingLeft: "0px"}} />
    }

    return(
        <div className={`app ${loading ? "disabled" : ""}`}>
            {
                loading &&
                <div className="spinner-overlay">
                    <ProgressSpinner style={{ width: "50px", height: "50px" }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                </div>
            }
            <Toast ref={toast} />

            <div className="worksheets-section">
                <h4>Fitters</h4>
                <DataTable className="font-12" value={fitters} datakey="fitterId" paginator rows={10} rowsPerPageOptions={[10, 20, 50]}
                            selectionMode="single" selection={selectedFitter} onSelectionChange={(e) => setSelectedFitter(e.value)}
                            onRowSelect={onRowSelect} metaKeySelection={false}
                            filters={filters} header={header}
                            globalFilterFields={["fitterId", "firstName", "middleName", "lastName", "email", "phone", "depot", "depotCode", "primaryFitter", "userName", "passwordHash", "isActive"]}
                            scrollable tableStyle={{ minWidth: "100rem" }}>
                    <Column field="fitterId" header="Fitter Id" hidden></Column>
                    <Column field="firstName" header="First Name"></Column>
                    <Column field="middleName" header="Middle Name"></Column>
                    <Column field="lastName" header="Last Name"></Column>
                    <Column field="email" header="Email"></Column>                    
                    <Column field="phone" header="Phone"></Column>
                    <Column field="depot" header="Depot"></Column>
                    <Column field="depotCode" header="Depot Code" hidden></Column>
                    <Column field="isPrimaryFitter" header="Primary Fitter"></Column>
                    <Column field="userName" header="User Name"></Column>
                    <Column field="passwordHash" header="Password Hash" hidden></Column>
                    <Column field="isActive" header="IsActive"></Column>
                    <Column header="Generate QRCode" body={getQRCodeButton} />
                </DataTable>
            </div>
            <Dialog header={isAddFitter ? "Add Fitter" : "Edit Details"} visible={showFitterModal} style={{ width: "50vw" }} 
                onHide={onModalClose} footer={showFitterFields ? footerContent : ""}>
                <div className="row">
                    { isAddFitter &&
                        <div className="row padb-10">
                            <div className="col-12 col-sm-5 col-md-5 col-lg-5 col-xl-5 padt-10">
                                <label>Does the Fitter Exists in the Planner:</label>
                            </div>
                            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 padr-20">
                                <div className="flex padb-20 padt-10">
                                    <RadioButton inputId="existingFitter" name="Yes" value="Yes" onChange={handleIsExistsInPlanner} checked={isFitterExistsInPlanner === true} />
                                    <label htmlFor="existingFitter" className="ml-2" style={{ paddingLeft: "10px" }}>Yes</label>
                                </div>
                            </div>
                            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 padr-20">
                                <div className="flex padb-20 padt-10">
                                    <RadioButton inputId="newFitter" name="No" value="No" onChange={handleIsExistsInPlanner} checked={isFitterExistsInPlanner === false} />
                                    <label htmlFor="newFitter" className="ml-2" style={{ paddingLeft: "10px" }}>No</label>
                                </div>
                            </div>
                        </div>
                    }
                    
                    { isFitterExistsInPlanner && 
                        <div className="row">
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                                <div className="flex flex-column gap-2 fitter-feild">
                                    <label htmlFor="fitterNames">Existing Fitters</label>
                                    <Dropdown value={selectedFitterFromPlanner} onChange={handleExistingFitterSelection} options={fittersFromPlannerNotInFitapp} optionLabel="fitterId" 
                                        placeholder="Select Fitter" className="w-full md:w-14rem" />
                                </div>
                            </div>
                        </div>
                    }
                    { showFitterFields &&
                        <div className="row">
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                                <div className="flex flex-column gap-2 fitter-feild">
                                    <label htmlFor="firstName">First Name</label>
                                    <InputText value={firstName} id="firstName" onChange={(e) => setFirstName(e.target.value)} className="p-inputtext-sm" />
                                    {firstNameError && <small className="p-error">This field is required</small>}
                                </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                                <div className="flex flex-column gap-2 fitter-feild">
                                    <label htmlFor="middleName">Middle Name</label>
                                    <InputText value={middleName} id="middleName" onChange={(e) => setMiddleName(e.target.value)} className="p-inputtext-sm" />
                                </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                                <div className="flex flex-column gap-2 fitter-feild">
                                    <label htmlFor="lastName">Last Name</label>
                                    <InputText value={lastName} id="lastName" onChange={(e) => setLastName(e.target.value)} className="p-inputtext-sm" />
                                    {lastNameError && <small className="p-error">This field is required</small>}
                                </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                                <div className="flex flex-column gap-2 fitter-feild">
                                    <label htmlFor="email">Email</label>
                                    <InputText value={email} id="email" onChange={(e) => setEmail(e.target.value)} className="p-inputtext-sm" />
                                </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                                <div className="flex flex-column gap-2 fitter-feild">
                                    <label htmlFor="phone">Phone</label>
                                    <InputText value={phone} id="phone" onChange={(e) => setPhone(e.target.value)} className="p-inputtext-sm" />
                                    {phoneError && <small className="p-error">Please enter a valid UK phone number.</small>}
                                </div>
                            </div>

                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                                <div className="flex flex-column gap-2 fitter-feild">
                                    <label htmlFor="depot">Depot</label>
                                    <Dropdown value={depot} onChange={(e) => setDepot(e.value)} options={depots} optionLabel="depot" 
                                        placeholder="Select Depot" className="w-full md:w-14rem" />
                                    {depotError && <small className="p-error">This field is required</small>}
                                </div>
                            </div>

                            {
                                !isAddFitter &&
                                <div>
                                    <div className="col-12 padr-20">
                                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                                            <div className="flex flex-column gap-2 fitter-feild">
                                                <label htmlFor="userName">User Name</label>
                                                <InputText value={userName} id="userName" onChange={(e) => setUserName(e.target.value)} className="p-inputtext-sm" />
                                                {userNameError && <small className="p-error">This field is required</small>}
                                            </div>
                                        </div>
                                    </div> 
                                    <div>
                                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                                            <div className="flex flex-column gap-2 fitter-feild">
                                                <label htmlFor="newPassword">New Password</label>
                                                <input type="password" className="form-control mrb-10" id="txt-password" name="newPassword" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                                            </div>
                                        </div>

                                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                                            <div className="flex flex-column gap-2 fitter-feild">
                                                <label htmlFor="confirmPassword">Confirm Password</label>
                                                <input type="password" className="form-control mrb-10" id="confirmPassword" name="confirmPassword" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                            <div className="col-12 padr-20 padb-20">
                                <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                    <div className="flex flex-column gap-2">
                                        <label htmlFor="isPrimaryFitter" className="padr-5">IsPrimaryFitter</label>
                                        <Checkbox value={isPrimaryFitter} id="isPrimaryFitter" onChange={e => setIsPrimaryFitter(e.checked)} checked={isPrimaryFitter}></Checkbox>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 padr-20">
                                <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                    <div className="flex flex-column gap-2">
                                        <label htmlFor="isActive" className="padr-5">IsActive</label>
                                        <Checkbox value={isActive} id="isActive" onChange={e => setIsActive(e.checked)} checked={isActive}></Checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }                                        
                </div>
            </Dialog>
        </div>
    )
}

export default Fitters;